import { AxiosInstance } from 'axios'
import Vue from 'vue'
import axiosInstance from '@/plugins/axios'

declare module 'vue/types/vue' {
    interface Vue {
        $http: AxiosInstance;
        $bus: Vue;
    }
}

Vue.prototype.$http = axiosInstance
Vue.prototype.$bus = new Vue()

Vue.config.productionTip = false
